import { Box, Grid } from "@mui/material";
import FormikControl from "../../../bmr/components/common/FormikControl";

const LSMApprovalDetails = ({ formik }) => {

    const formOptions = [
        {
            label: 'Reason',
            type: 'text',
            name: 'reason_id',
            disabled: true,
            placeholder: "reason",
        },
        {
            label: 'CD3 Count',
            type: 'number',
            disabled: true,
            required:true,
            name: 'cd3_count',
            placeholder: "Enter the CD3 Count",
        },
        {
            label: 'Remarks ( Manufacture )',
            type: 'textarea',
            name: 'comment',
            disabled: true,
            placeholder: 'Enter Comment',
        },
    ];

    return (<Box className="p-3 flex flex-col gap-3"> {formOptions.map((props, key) => (
        <Grid key={key} item xs={12}>
            <FormikControl formik={formik} {...props} />
        </Grid>
    ))}
    </Box>
    )
}

export default LSMApprovalDetails;